import { ReactComponent as Asset } from '../assets/logo-primary-bob-secondary.svg';
import React from 'react';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

const LogoPrimaryBobSecondary = (props: {style?: CSSProperties; className?: string}) => {
    return (
        <Asset className={props.className} />
    );
}

export { LogoPrimaryBobSecondary };